<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 resellerInvoice-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("RESELLER_INVOICES.ADD_RESELLER_INVOICE") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <resellerInvoice-form
              :loading="loading"
              :resellerInvoiceData="resellerInvoice"
              :formErrors="formErrors"
              @resellerInvoiceSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultResellerInvoice from "./defaultResellerInvoice";
import ResellerInvoiceForm from "./partials/ResellerInvoiceForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ResellerInvoiceForm,
  },

  mixins: [alertLeave],

  data() {
    const resellerInvoice = cloneDeep(defaultResellerInvoice);
    return {
      resellerInvoice: resellerInvoice,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List ResellerInvoices" });
    },

    viewResellerInvoice(resellerInvoice) {
      this.alertLeave = false;
      this.$router.push({
        name: "View ResellerInvoice",
        params: { id: resellerInvoice.id },
      });
    },

    async handleSubmit(resellerInvoice) {
      this.loading = true;
      const resellerInvoiceData = cloneDeep(resellerInvoice);
      try {
        await this.$store.dispatch("resellerInvoices/add", resellerInvoiceData);
        this.$notify({
          type: "success",
          message: this.$t("RESELLER_INVOICES.RESELLER_INVOICE_ADDED"),
        });
        const resellerInvoice = await this.$store.getters[
          "resellerInvoices/resellerInvoice"
        ];
        this.viewResellerInvoice(resellerInvoice);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
